import {
  Checkbox,
  Divider,
  Text,
  makeStyles,
  type CheckboxOnChangeData,
} from "@fluentui/react-components";
import * as React from "react";
import { usePromptFilterLocalizations } from "../PromptFilter/usePromptFilterStrings";
import type { FilterOption } from "./types";

const useStyles = makeStyles({
  groupOptions: {
    display: "flex",
    gap: "2px",
    flexDirection: "column",
  },

  groupHeader: {
    padding: "6px 6px 6px 8px",
  },

  groupDivider: {
    padding: "5px 0px 4px 0px",
  },
});

type Props = {
  groupKey: string;
  filterOptions: FilterOption[];
  selectedValues: string[] | undefined;
  isLastItem: boolean;

  /**
   * Callback for changed event.
   */
  onChange: (
    ev: React.ChangeEvent<HTMLInputElement>,
    data: CheckboxOnChangeData
  ) => void;
};

export const CheckboxAccordionItem: React.FC<Props> = ({
  groupKey,
  filterOptions,
  selectedValues,
  isLastItem,
  onChange,
}) => {
  const styles = useStyles();
  const { facetValueToLabel } = usePromptFilterLocalizations();
  const options = filterOptions.map((x) => {
    const checked = !!selectedValues?.includes(x.value);
    return (
      <Checkbox
        size="large"
        label={x.displayLabel || facetValueToLabel(x.value)}
        value={x.value}
        key={x.value}
        checked={checked}
        aria-checked={checked}
        onChange={onChange}
      />
    );
  });

  if (groupKey === "NA") {
    return <>{options}</>;
  }

  return (
    <div className={styles.groupOptions}>
      <Text className={styles.groupHeader}>{groupKey}</Text>
      {options}
      {!isLastItem && <Divider className={styles.groupDivider} />}
    </div>
  );
};
